import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

/**
 * Guard that only allows access in development mode.
 * In production, redirects to error page.
 */
export const devGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void => {
  if (import.meta.env.MODE === 'production') {
    next({ name: 'error', params: { key: 'errors.client.bad_request' } })
  } else {
    next()
  }
}
